const { makeStyles } = require('@material-ui/core');

export const tableActionContainerStyles = makeStyles({
  container: {
    '&> button': {
      marginRight: 4,
    },
    cursor: 'default',
    display: 'inline-block',
  },
});
